import { translate } from "app/language/service"
import { IMediaApprovalData } from "media/model"
import { getMediaApprovalData } from "media/repository"
import React from "react"
import { Popup } from "ui/components/Popup"
import { MediaApprovalDisplay } from "./MediaApprovalDisplay"

interface IMediaApprovalPopupProps {
  mediaApprovalDatas: IMediaApprovalData[]
  defaultMediaApprovalData: IMediaApprovalData
  onClose: () => any
}

export const MediaApprovalPopup = React.memo(
  ({ mediaApprovalDatas, defaultMediaApprovalData, onClose }: IMediaApprovalPopupProps): JSX.Element => {
    const [mediaApprovalData, setMediaApprovalData] = React.useState(defaultMediaApprovalData)
    return (
      <Popup
        id="media-approval-popup"
        title={translate("media-approval.title")}
        displayCloseIcon
        onClose={() => onClose()}
        maxWidth="" // unset the default max-width
        sx={{
          "& .MuiDialogContent-root": {
            p: "1rem",
            pt: 0
          },
          "& .MuiPaper-root": {
            maxWidth: "100%"
          }
        }}>
        <MediaApprovalDisplay
          mediaApprovalsByMedias={mediaApprovalDatas.map(m => m.mediaApprovalsByMedia)}
          mediaApprovalsByMediasDefaultIndex={Math.max((mediaApprovalDatas || []).indexOf(mediaApprovalData), 0)}
          onMediaSelection={newMediaApprovalsByMedia =>
            setMediaApprovalData(getMediaApprovalData(newMediaApprovalsByMedia))
          }
        />
      </Popup>
    )
  }
)
